(function (angular) {

    window.app
        .directive('cookiesInfo', () => {
            return {
                template: `<div class="cookiesInfo" ng-if=checkCookiesRules()>
                            <div class="container text-center"
                                layout="row"
                                layout-xs="column"
                                layout-align="space-around center">
                                
                                <div class="cookiesInfo__text" flex="80" flex-xs="100">
                                    <span class="font-18">UŻYWANIE COOKIES</span>
                                    <p class="font-12">
                                    Pragniemy poinformować, że nasz portal korzysta z ciasteczek (pliki cookies). 
                                    Korzystając z naszego portalu bez zmiany ustawień Twojej przeglądarki wyrażasz 
                                    zgodę na wykorzystanie przez nas plików cookies. W każdej chwili możesz zmienić 
                                    ustawienia plików cookies. Więcej informacji możesz znaleźć w 
                                    <span   class="link-success" 
                                            ng-click="showDialog($event, serviceData.consent.privacyPolicy)">
                                        Polityce prywatności
                                    </span>
                                    </p>
                                </div>
                                <md-button class="cookiesInfo__btn bolder" style="font-size: 12px;
                                background: #19A0E5;
                                border-radius: 24px;
                                text-transform: uppercase;
                                margin: 10px;
                                width: 140px;"
                                    ng-click="agreeCookiesRules()"
                                    flex="20"
                                    flex-xs="80">
                                    Zgadzam się
                                </md-button>
                            </div>
                        </div>`
            };
        })

        .directive("compareTo", function () {
            return {
                require: "ngModel",
                scope: {
                    otherModelValue: "=compareTo"
                },
                link: function (scope, element, attributes, ngModel) {

                    ngModel.$validators.compareTo = function (modelValue) {
                        return modelValue == scope.otherModelValue;
                    };

                    scope.$watch("otherModelValue", function () {
                        ngModel.$validate();
                    });
                }
            };
        })

        .directive("notMatched", function () {
            return {
                require: "ngModel",
                scope: {
                    otherModelValue: "=notMatched" 
                },
                link: function (scope, element, attributes, ngModel) {

                    ngModel.$validators.notMatched = function (modelValue) {
                        return modelValue != scope.otherModelValue;
                    };

                    scope.$watch("otherModelValue", function () {
                        ngModel.$validate();
                    });
                }
            };
        })

        .directive("notSelected", function () {
            return {
                require: "ngModel",
                scope: {
                    otherModelValue: "=notSelected"
                },
                link: function (scope, element, attributes, ngModel) {
                    ngModel.$validators.notSelected = function (modelValue) {
                        return modelValue != attributes.notSelected;
                    };
                }
            };
        })

        .directive('loaderFullScreen', () => {
            return {
                template: `<div class=\"loader-fullScreen fixed-center\">
                        <div class=\"loadDots \">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                        </div>`
            };
        })

        .directive('faqInfo', () => {
            return {
                scope: {
                    faq: '='
                },
                template: `
                    <div class="faq_unit">
                        <div class="faq_title" ng-click="faqExpand($event)" id="{{faq.id}}">{{faq.title}}</div>
                        <div class="faq_text" ng-bind-html="faq.text" >
                        </div>
                    </div>
                `,
            }
        })

        .directive('bikFishLoader', () => {
            return {
                template: `<div class=\"bikFishLoader fixed-center\">
                    <div class=\"bk-loader-ctn \">
                        <section class=\"message\">
                            Dziękujemy za wniosek. Poczekaj, teraz zostaniesz przekierowany na stronę firmy dostawcy Usługi «SMART skaner»
                        </section>
                        <div class=\"loadDots \">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>

                </div>`
            };
        })


        .directive('btnToTop', () => {
            return {
                template: `<div class=\"btn-to-top w600\" 
                            ng-click=\"scrollTo('body', 1000)\" 
                            hide-xs 
                            hide-sm
                            aria-label="scroll-to-top">
                            <span class=\"w500\">
                                Powrót do góry
                                <i class=\"fa fa-long-arrow-right\"></i>
                            </span>
                        </div>`
            };
        })
        .directive('file', function () {
            return {
                scope: {
                    file: '='
                },
                link: function (scope, el, attrs) {
                    el.bind('change', function (event) {
                        var files = event.target.files;
                        var file = files[0];
                        scope.file = file ? file.name : undefined;
                        scope.$apply();
                    });
                }
            };
        })
        .directive('stringToNumber', function () {
            return {
                require: 'ngModel',
                link: function (scope, element, attrs, ngModel) {
                    ngModel.$parsers.push(function (value) {
                        return '' + value;
                    });
                    ngModel.$formatters.push(function (value) {
                        return parseFloat(value);
                    });
                }
            };
        })

        .directive('emailInput', function () {
            let EMAIL_REGEXP = /^[a-zA-Z0-9]+[a-zA-Z0-9._-]+@[a-z0-9]+\.[a-z]{2,7}$/;

            return {
                require: 'ngModel',
                restrict: '',
                link: function (scope, elm, attrs, ctrl) {
                    // only apply the validator if ngModel is present and Angular has added the email validator
                    if (ctrl && ctrl.$validators.email) {
                        // this will overwrite the default Angular email validator
                        ctrl.$validators.email = function (modelValue) {
                            return ctrl.$isEmpty(modelValue) || EMAIL_REGEXP.test(modelValue);
                        };
                    }
                }
            }
        })

        .directive("ngFileSelect", function (fileReader, $timeout) {
            return {
                scope: {
                    ngModel: '='
                },
                link: function ($scope, el) {
                    function getFile(file) {
                        fileReader.readAsDataUrl(file, $scope)
                            .then(function (result) {
                                $timeout(function () {
                                    $scope.ngModel = result;
                                });
                            });
                    }

                    el.bind("change", function (e) {
                        var file = (e.srcElement || e.target).files[0];
                        getFile(file);
                    });
                }
            };
        })

        .directive('checkFileSize', function () {
            return {
                link: function ($scope, elem, attr, ctrl) {
                    function bindEvent(element, type, handler) {
                        if (element.addEventListener) {
                            element.addEventListener(type, handler, false);
                        } else {
                            element.attachEvent('on' + type, handler);
                        }
                    }

                    bindEvent(elem[0], 'change', function () {
                        if (this.files[0].size > 50000) {
                            return $scope.fileSize = true;
                        }
                        return $scope.fileSize = false;
                    });
                },
            }
        })

        .directive('checkFileType', function () {
            return {
                link: function ($scope, elem, attr, ctrl) {
                    function bindEvent(element, type, handler) {
                        if (element.addEventListener) {
                            element.addEventListener(type, handler, false);
                        } else {
                            element.attachEvent('on' + type, handler);
                        }
                    }

                    bindEvent(elem[0], 'change', function () {
                        if (this.files[0].type === "image/png") {
                            return $scope.fileType = false;
                        }
                        return $scope.fileType = true;
                    });
                },
            }
        })
        .directive('checkExelFileSize', function () {
            return {
                link: function ($scope, elem, attr, ctrl) {
                    function bindEvent(element, type, handler) {
                        if (element.addEventListener) {
                            element.addEventListener(type, handler, false);
                        } else {
                            element.attachEvent('on' + type, handler);
                        }
                    }

                    bindEvent(elem[0], 'change', function () {
                        if (this.files[0].size > 10000000) {
                            return $scope.fileSize = true;
                        }
                        return $scope.fileSize = false;
                    });
                },
            }
        })

        .directive('getFileName', function () {
            return {
                link: function ($scope, elem, attr, ctrl) {
                    function bindEvent(element, type, handler) {
                        if (element.addEventListener) {
                            element.addEventListener(type, handler, false);
                        } else {
                            element.attachEvent('on' + type, handler);
                        }
                    }

                    bindEvent(elem[0], 'change', function () {
                        $scope.uplFileName = document.getElementById('partnerDoc').files[0].name;
                        console.log($scope.uplFileName);
                    });
                },
            }
        })

        .directive('getFileSize', function () {
            return {
                link: function ($scope, elem, attr, ctrl) {
                    function bindEvent(element, type, handler) {
                        if (element.addEventListener) {
                            element.addEventListener(type, handler, false);
                        } else {
                            element.attachEvent('on' + type, handler);
                        }
                    }

                    bindEvent(elem[0], 'change', function () {
                        $scope.uplFileSize = parseFloat(((document.getElementById('partnerDoc').files[0].size) / 1024)).toFixed(0) + ' kb';
                    });
                },
            }
        })

        .directive('checkExelFileType', function () {
            return {
                link: function ($scope, elem, attr, ctrl) {
                    function bindEvent(element, type, handler) {
                        if (element.addEventListener) {
                            element.addEventListener(type, handler, false);
                        } else {
                            element.attachEvent('on' + type, handler);
                        }
                    }

                    bindEvent(elem[0], 'change', function () {
                        if (this.files[0].type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                            this.files[0].type === "application/vnd.ms-excel") {
                            return $scope.fileType = false;
                        }
                        return $scope.fileType = true;
                    });
                },
            }
        })
        .directive('fileModel', ['$parse', function ($parse) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    var model = $parse(attrs.fileModel);
                    var modelSetter = model.assign;

                    element.bind('change', function () {
                        scope.$apply(function () {
                            modelSetter(scope, element[0].files[0]);
                        });
                    });
                }
            };
        }])
        .directive('disallowSpaces', function () {
            return {
                restrict: 'A',

                link: function ($scope, $element) {
                    $element.bind('keydown', function (e) {
                        if (e.which === 32) {
                            e.preventDefault();
                        }
                    });
                }
            }
        })
        .directive('tip', function () {
            return {
                restrict: 'A',
                scope: {
                    tip: '@tip',
                    trigger: '@trigger'
                },
                link: function (scope, element, attrs) {
                    var tooltip = `<p class="partnerData_tip">${scope.tip}</p>`;
                    element.append(tooltip);
                    element.bind('mouseenter mouseleave', function () {
                        element.children('.partnerData_tip').toggleClass('active');
                    });
                }
            }
        })
        .directive('showTip', function () {
            return {
                restrict: 'A',
                link: function (scope, element) {
                    element.on('mouseover', function () {
                        element.children('.partnerData_tip').addClass('active');
                    });
                    element.on('mouseleave', function () {
                        element.children('.partnerData_tip').removeClass('active');
                    });
                    // element.on('click', function() {
                    //     element.children('.partnerData_tip').hasClass('active') ? $(element).children('.partnerData_tip').removeClass('active') : $(element).children('.partnerData_tip').addClass('active');
                    // });
                }
            }
        })

        .directive('setPrefix', function () {
            return {
                link: function (scope, element, attributes) {
                    $(`input[name=${attributes.name}]`).focus(function () {
                        let input = $(`input[name=${attributes.name}]`)
                        if (!input.val()) {
                            input.val(`${attributes.setPrefix}`);
                        }
                    });
                }
            };
        })

        .directive('socialNumberInput', function () {
            return {
                link: function (scope, element, attributes) {
                    $(`input[name=${attributes.name}]`).keyup(function () {
                        var input = $(`input[name=${attributes.name}]`);
                        input.val(input.val().toUpperCase());
                        if (input.val().length <= 3) {
                            input.val(input.val().replace(/[\d]/g, ''));
                        }
                        if (input.val().length > 3) {
                            input.val(input.val().slice(0, 3) + input.val().slice(3).replace(/[a-zA-Z]/g, ''));
                        }
                    });
                }
            };
        })

        .directive('postCodeInput', function () {
            return {
                link: function (scope, element, attributes) {
                    $(`input[name=${attributes.name}]`).keyup(function () {
                        var input = $(`input[name=${attributes.name}]`);
                        if (input.val().length >= 3 && input.val()[2] !== '-') {
                            input.val(input.val().slice(0, 2) + '-' + input.val().slice(2, input.val().length))
                            // input.val(input.val().slice(0, 2)+'-'+input.val()[2])
                        }
                    });
                }
            };
        })

        .directive('delFailSymbol', function () {
            return {
                link: function (scope, element, attributes) {
                    $(`input[name=${attributes.name}]`).keyup(function () {
                        var input = $(`input[name=${attributes.name}]`);
                        var pattern = /[' ', '-', '  ', '--', ' -', '\'']/;
                        if (pattern.test(input.val())) {
                            var fw = input.val()[0];
                            if (fw == ' ' || fw == '-' || fw == '\'') input.val('');
                            input.val(input.val().replace(/  /g, ' '));
                            input.val(input.val().replace(/--/g, '-'));
                            input.val(input.val().replace(/[\-]+[\s]|[\s]+[\-]|[\']+[\']/g, ''));
                        }
                    })
                }
            };
        })

    // .directive('whenScrolled', function() {
    //     return function(scope, elm, attr) {
    //         var raw = elm[0];
    //         elm.bind('scroll', function() {
    //             if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight) {
    //                 scope.$apply(attr.whenScrolled);
    //             }
    //         });
    //     };
    // });

})(window.angular);



// WEBPACK FOOTER //
// src/js/controllers/directives.js